import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'


export interface IMeiosPagamento extends IDataModel {
    nome?:string,
    operacao?: string,
    ordem?: number,
    img?:string,
    maxParcelas?:number  ,
}

export class MeiosPagamento extends DataModel<IMeiosPagamento>  {
    constructor(private db: AngularFirestore) {
        super(db,"meiosPagamento");
    }
}
